<template>
  <div class>
    <div
      :class="styles.bgPage[globalStyles.bgPage]"
      class="antialiased md:h-auto print:h-full"
    >
      <tool-navbar
        :globalStyles="globalStyles"
        @selectedJSONFile="onLoadJsonFile"
        @changeColor="onChangeColor"
        @changeFont="changeFont"
        @changeLayout="onChangeLayout"
        @print="showModalPrint = true"
        @showInfo="showModalAbout = true"
      >
        <a
          class="relative flex items-center w-full group hover:bg-gray-500 focus:outline-none hover:text-gray-50"
          href="#"
          id="downloadAnchorElem"
          download
          @click="downloadJson"
        >
          <svg
            class="relative flex-shrink-0 w-5 h-5 mx-4 my-2 text-gray-300 group-hover:text-gray-200"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
          <span class="text-sm font-medium text-gray-200">{{
            $t("toolbar.files.save")
          }}</span>
        </a>
      </tool-navbar>
      <!-- Fin barra de herramientas -->
      <span
        class="fixed z-10 rounded-full bottom-20 left-8 md:hidden print:hidden"
      >
        <button
          class="text-center bg-gray-800 bg-opacity-75 rounded-full border-cool-gray-400 border-2 shadow-outline-blue"
          @click="openSideOver = !openSideOver"
        >
          <svg
            class="relative flex-shrink-0 m-2 text-blue-100 w-7 h-7"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
            />
          </svg>
        </button>
      </span>

      <!-- mobile view -->
      <div
        class="w-full md:hidden print:hidden mx-auto h-test2"
        style="
          max-height: 472px;
          max-width: 334px;
          min-height: calc(100vh - 4rem);
        "
      >
        <div style="max-height: 472px; max-width: 334px">
          <div class="scaled page overflow-hidden origin-top-left">
            <modern-layout
              :globalStyles="globalStyles"
              v-if="globalStyles.layout === 'modern'"
            ></modern-layout>
            <simple-layout
              :globalStyles="globalStyles"
              v-if="globalStyles.layout === 'simple'"
            ></simple-layout>
            <simple-variant
              :globalStyles="globalStyles"
              v-if="globalStyles.layout === 'simple-variant'"
            ></simple-variant>
            <modern-variant
              :globalStyles="globalStyles"
              v-if="globalStyles.layout === 'modern-variant'"
            ></modern-variant>
            <elegante
              :globalStyles="globalStyles"
              v-if="globalStyles.layout === 'elegante'"
            ></elegante>
            <EleganteVariant
              :globalStyles="globalStyles"
              v-if="globalStyles.layout === 'elegante-variant'"
            ></EleganteVariant>
          </div>
        </div>
      </div>
      <!-- desktop view -->
      <div class="grid w-full grid-cols-8 gap-4 h-full grid-flow-row-dense">
        <div class="hidden px-2 print:hidden col-span-3 md:block">
          <data-composition @print="showModalPrint = true"></data-composition>
        </div>
        <div
          class="hidden mx-auto overflow-hidden print:col-start-1 col-start-4 col-span-5 page md:block print:block transform scale-75 lg:scale-100 print:scale-100 origin-top-left"
          size="A4"
          :class="globalStyles.font"
        >
          <transition
            enter-active-class="transition duration-200 ease-out transform"
            enter-class="scale-95 opacity-0"
            enter-to-class="scale-100 opacity-100"
            leave-active-class="transition duration-200 ease-in transform"
            leave-class="scale-100 opacity-100"
            leave-to-class="scale-95 opacity-0"
          >
            <simple-layout
              :globalStyles="globalStyles"
              v-if="globalStyles.layout === 'simple'"
            ></simple-layout>
          </transition>
          <div v-if="globalStyles.layout === 'elegante'" class="h-full">
            <transition
              enter-active-class="transition duration-200 ease-out transform"
              enter-class="scale-95 opacity-0"
              enter-to-class="scale-100 opacity-100"
              leave-active-class="transition duration-200 ease-in transform"
              leave-class="scale-100 opacity-100"
              leave-to-class="scale-95 opacity-0"
            >
              <elegante :globalStyles="globalStyles"></elegante>
            </transition>
          </div>
          <div v-if="globalStyles.layout === 'elegante-variant'" class="h-full">
            <transition
              enter-active-class="transition duration-200 ease-out transform"
              enter-class="scale-95 opacity-0"
              enter-to-class="scale-100 opacity-100"
              leave-active-class="transition duration-200 ease-in transform"
              leave-class="scale-100 opacity-100"
              leave-to-class="scale-95 opacity-0"
            >
              <EleganteVariant
                :globalStyles="globalStyles"
                v-if="globalStyles.layout === 'elegante-variant'"
              ></EleganteVariant>
            </transition>
          </div>
          <div v-if="globalStyles.layout === 'modern'" class="h-full">
            <transition
              enter-active-class="transition duration-200 ease-out transform"
              enter-class="scale-95 opacity-0"
              enter-to-class="scale-100 opacity-100"
              leave-active-class="transition duration-200 ease-in transform"
              leave-class="scale-100 opacity-100"
              leave-to-class="scale-95 opacity-0"
            >
              <modern-layout :globalStyles="globalStyles"></modern-layout>
            </transition>
          </div>
          <div v-if="globalStyles.layout === 'modern-variant'" class="h-full">
            <transition
              enter-active-class="transition duration-200 ease-out transform"
              enter-class="scale-95 opacity-0"
              enter-to-class="scale-100 opacity-100"
              leave-active-class="transition duration-200 ease-in transform"
              leave-class="scale-100 opacity-100"
              leave-to-class="scale-95 opacity-0"
            >
              <modern-variant :globalStyles="globalStyles"></modern-variant>
            </transition>
          </div>
          <div v-if="globalStyles.layout === 'simple-variant'" class="h-full">
            <transition
              enter-active-class="transition duration-200 ease-out transform"
              enter-class="scale-95 opacity-0"
              enter-to-class="scale-100 opacity-100"
              leave-active-class="transition duration-200 ease-in transform"
              leave-class="scale-100 opacity-100"
              leave-to-class="scale-95 opacity-0"
            >
              <simple-variant :globalStyles="globalStyles"></simple-variant>
            </transition>
          </div>
        </div>
      </div>
      <div class="print:hidden">
        <slide-over :open="openSideOver" @close="openSideOver = false">
          <data-composition @print="showModalPrint = true"></data-composition>
        </slide-over>

        <!-- <simple-layout
          :globalStyles="globalStyles"
          v-show="globalStyles.layout==='simple'"
          class="bg-white md:hidden print:hidden"
        ></simple-layout>-->
        <!-- <modern-layout
          :globalStyles="globalStyles"
          v-show="globalStyles.layout==='modern'"
          class="bg-white md:hidden print:hidden"
        ></modern-layout>-->
      </div>
      <!-- footer -->
      <div
        class="items-center justify-center w-full py-2 text-sm bg-gray-900 md:mt-4 print:hidden hidden md:flex"
      >
        <span class="mr-2 italic font-medium text-gray-400">{{
          $t("footer.text")
        }}</span>
        <a
          href="https://twitter.com/sansildev"
          target="__blank"
          class="font-medium text-gray-300 underline"
          >{{ $t("footer.author") }}</a
        >
      </div>
      <router-view />
      <base-modal
        :show="showModalPrint"
        @close="showModalPrint = false"
        class="print:hidden"
      >
        <div class="p-6 bg-white rounded-lg shadow-xl sm:max-w-sm sm:w-full">
          <div
            class="flex items-center justify-center w-12 h-12 mx-auto bg-green-100 rounded-full"
          >
            <svg
              class="w-6 h-6 text-green-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"
              />
            </svg>
          </div>
          <h1
            class="py-4 text-lg font-semibold leading-6 text-center text-gray-800"
          >
            Exportar a PDF
          </h1>
          <p class="text-sm leading-5 text-gray-500">
            La función exportar a pdf aún esta en desarrollo, pero es posible
            exportar el archivo a pdf utilizando la función
            <span class="font-semibold text-gray-600">imprimir</span>
            de los navegadores.
          </p>
          <p class="text-sm leading-5 text-gray-500">
            Recomendamos utilizar el navegador
            <span class="font-semibold text-gray-600">chrome</span> (o
            navegadores basados en chrome) para obtener mejores resultados.
          </p>
          <br />
          <p class="text-sm leading-5 text-gray-500">
            Si tienes algún problema recuerda poner los
            <span class="font-semibold text-gray-600">margenes a cero</span> ,
            habilitar la opción
            <span class="font-semibold text-gray-600">gráficos de fondo</span> y
            finalmente
            <span class="font-semibold text-gray-600">guardar como pdf</span>.
          </p>
          <div class="mt-5 sm:mt-6">
            <button
              @click="
                print();
                showModalPrint = false;
              "
              class="w-full px-3 py-2 font-medium leading-6 text-blue-100 bg-blue-500 rounded-lg focus:outline-none hover:bg-blue-400 hover:text-white"
            >
              Continuar
            </button>
          </div>
        </div>
      </base-modal>
      <base-modal
        :show="showModalAbout"
        @close="showModalAbout = false"
        :withCloseButton="false"
      >
        <div
          class="p-6 font-mono bg-white rounded-lg shadow-xl sm:max-w-sm sm:w-full"
        >
          <div
            class="flex items-center justify-center w-12 h-12 mx-auto bg-gray-100 rounded-full"
          >
            <svg
              class="w-6 h-6 text-gray-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          <h1
            class="py-4 text-lg font-semibold leading-6 text-center text-gray-800"
          >
            miCurriculum
          </h1>
          <div class="text-base leading-6 text-gray-500 my-4">
            <a
              href="https://micurriculum.uy/cv/ejemplo"
              target="__blank"
              class="underline text-sm"
              >{{ $t("toolbar.info.example") }}</a
            >
          </div>
          <div class="flex my-2">
            <div class="flex-shrink-0">
              <svg
                class="w-6 h-6 text-gray-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
            </div>

            <div class="ml-3 text-base leading-6 text-gray-500">
              <p>sansil.uy.dev@gmail.com</p>
            </div>
          </div>

          <!-- <a
            href="https://twitter.com/sansildev"
            target="__blank"
            class="text-gray-400 hover:text-gray-500"
          >
            <span class="sr-only">Twitter</span>
            <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
              <path
                d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"
              />
            </svg>
          </a>-->
          <p class="mt-2 text-sm leading-5 text-gray-500">
            {{ $t("toolbar.info.feedback") }}
            <a
              href="https://forms.gle/5fScf1JeERkrys8d8"
              target="__blank"
              class="font-medium underline"
              >{{ $t("toolbar.info.feedbackButton") }}</a
            >.
          </p>
          <p class="mt-2 text-sm leading-5 text-gray-500">
            {{ $t("toolbar.info.privacy") }}
          </p>
          <p class="text-sm leading-5 text-gray-500">
            {{ $t("toolbar.info.cookies") }}
          </p>
          <div class="mt-5 sm:mt-6">
            <button
              @click="showModalAbout = false"
              class="w-full px-3 py-2 font-medium leading-6 text-blue-100 bg-blue-500 rounded-lg focus:outline-none hover:bg-blue-400 hover:text-white"
            >
              {{ $t("toolbar.info.buttonName") }}
            </button>
          </div>
        </div>
      </base-modal>
    </div>
    <banner
      v-show="showBanner"
      @close="showBanner = false"
      class="print:hidden md:block hidden"
    ></banner>
  </div>
</template>


<script>
//import SimpleLayout from "@/components/SimpleLayout";

import DataComposition from "@/components/DataComposition";
import baseModal from "@/components/BaseModal.vue";
import { mapState, mapActions } from "vuex";
import EventBus from "@/eventBus";
import ToolNavbar from "@/components/ToolNavbar.vue";
import SlideOver from "@/components/SlideOver.vue";
// cv templates
import ModernVariant from "@/components/cvTemplates/ModernVariant.vue";
import SimpleVariant from "@/components/cvTemplates/SimpleVariant.vue";
import SimpleLayout from "@/components/cvTemplates/SimpleLayout.vue";
import ModernLayout from "@/components/cvTemplates/ModernLayout.vue";
import Elegante from "@/components/cvTemplates/Elegante.vue";
import Banner from "@/components/Banner.vue";
import EleganteVariant from "@/components/cvTemplates/EleganteVariant.vue";

export default {
  components: {
    //SimpleLayout,
    ModernLayout,
    DataComposition,
    baseModal,
    ToolNavbar,
    SlideOver,
    ModernVariant,
    SimpleVariant,
    SimpleLayout,
    Elegante,
    Banner,
    EleganteVariant,
  },
  data() {
    return {
      showBanner: true,
      selectedFile: null,
      showFonts: false,
      showLayouts: false,
      showColors: false,
      showFilesMenu: false,
      showModalPrint: false,
      showModalAbout: false,
      openSideOver: false,
      globalStyles: {
        layout: "simple",
        bg: "blue",
        bgPage: "blue",
        border: "blue",
        text: "blue",
        font: "font-sansprint",
        bgDarkest: "blue",
      },
    };
  },
  mounted() {},
  computed: {
    ...mapState([
      "skills",
      "idioms",
      "interests",
      "education",
      "work",
      "otherData",
      "basics",
      "projects",
      "references",
      "control",
    ]),
    ...mapState("style", ["styles"]),
  },
  methods: {
    ...mapActions([
      "updateWork",
      "updateSkills",
      "updateEducation",
      "updateBasics",
      "updateIdioms",
      "updateOtherData",
      "updateProyects",
      "updateControl",
      "updateInterests",
      "updateReferences",
    ]),
    closeColorsMenu: function () {
      // console.log("called outsideclick");
      this.showColors = false;
    },
    closeLayoutsMenu: function () {
      this.showLayouts = false;
    },
    closeFontsMenu: function () {
      this.showFonts = false;
    },
    closeFilesMenu: function () {
      this.showFilesMenu = false;
    },
    print() {
      window.print();
    },
    async downloadJson(event) {
      event.preventDefault();
      //console.log("donwload");
      const dataStr =
        "data:text/json;charset=utf-8," +
        encodeURIComponent(
          JSON.stringify({
            basics: this.basics,
            work: this.work,
            otherData: this.otherData,
            education: this.education,
            skills: this.skills,
            interests: this.interests,
            idioms: this.idioms,
            projects: this.projects,
            references: this.references,
            control: this.control,
            style: this.globalStyles,
          })
        );
      const dlAnchorElem = document.createElement("a");
      dlAnchorElem.setAttribute("href", dataStr);
      dlAnchorElem.setAttribute("download", "miCurriculum.json");
      dlAnchorElem.click();
    },
    onChangeLayout(layout) {
      this.globalStyles.layout = layout;
    },
    onLoadJsonFile() {
      this.selectedFile = event.target.files[0];
      const type = event.target.files[0].type;
      const size = this.selectedFile.size / 1024 / 1024;
      //console.log(size);
      if (size > 2) {
        //console.log("imagen mayor a 2 mb");
        this.selectedFile = null;
      }
      //console.log("subiendo archivooo");
      if (type != "application/json") {
        // console.log("archivo con extension invalida");
        this.selectedFile = null;
      }
      //console.log(URL.createObjectURL(this.selectedFile));
      let newData = [];
      this.loading = true;
      fetch(URL.createObjectURL(this.selectedFile))
        .then((response) => response.json())
        .then((json) => {
          const {
            work,
            skills,
            education,
            basics,
            idioms,
            otherData,
            projects,
            control,
            interests,
            references,
            style,
          } = json;
          newData = json;
          this.updateWork(work);
          this.updateSkills(skills);
          this.updateEducation(education);
          this.updateBasics(basics);
          this.updateIdioms(idioms);
          this.updateOtherData(otherData);
          this.updateProyects(projects);
          this.updateControl(control);
          this.updateInterests(interests);
          this.updateReferences(references);
          this.globalStyles = style;
          EventBus.$emit("CURRICULUM_LOADED", newData);
          this.loading = false;
        });
    },
    onChangeColor(color) {
      this.globalStyles.bg = color;
      this.globalStyles.bgPage = color;
      this.globalStyles.text = color;
      this.globalStyles.bgDarkest = color;
      this.globalStyles.border = color;
      // this.globalStyles.bg = `bg-${color}-500`;
      // this.globalStyles.bgPage = `bg-${color}-100`;
      // this.globalStyles.text = `text-${color}-500`;
      // this.globalStyles.bgDarkest = `bg-${color}-700`;
      // this.globalStyles.border = `border-${color}-500`;
    },
    changeFont(font) {
      this.globalStyles.font = `font-${font}`;
      this.showFonts = false;
    },
  },
};
</script>



<style >
body {
  -webkit-print-color-adjust: exact !important;
  min-height: -webkit-fill-available;
  height: 100%;
}
html {
  height: 100%;
}

::-webkit-scrollbar {
  width: 2px;
}

.page {
  background: white;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
}

.page[size="A4"] {
  width: 21cm;
  height: 29.699cm;
}

@media print {
  tr.vendorListHeading {
    -webkit-print-color-adjust: exact !important;
  }
}
@page {
  margin: 0;
}

@media (max-width: 1024px) {
  .scaled {
    width: 21cm;
    height: 29.699cm;
    -ms-transform: scale(0.42);
    -moz-transform: scale(0.42);
    -o-transform: scale(0.42);
    -webkit-transform: scale(0.42);
    transform: scale(0.42);
  }
  .scaled::after {
    max-height: 100px;
  }
}
</style>
